<template>
  <v-card
    v-if="
      (auditPeriod.userAttachments && auditPeriod.userAttachments.length) ||
        (auditPeriod.auditorAttachments && auditPeriod.auditorAttachments.length)
    "
  >
    <template v-if="auditPeriod.userAttachments && auditPeriod.userAttachments.length">
      <v-card-title>
        {{ $t("auditPeriodFiles.userFiles") }}

        <v-spacer></v-spacer>

        <v-dialog v-model="userAttachmentsDialog" persistent max-width="600">
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="secondary" icon>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline">
              {{ $t("auditor.download.confirmation.title") }}
            </v-card-title>

            <v-card-text>
              {{ $t("auditor.download.confirmation.description") }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="warning" @click="userAttachmentsDialog = false">
                {{ $t("auditor.download.confirmation.cancel") }}
              </v-btn>

              <v-btn
                color="primary"
                @click="
                  download(auditPeriod.userAttachments);
                  userAttachmentsDialog = false;
                "
              >
                {{ $t("auditor.download.confirmation.accept") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>

      <AuditPeriodFilesTable :attachments="auditPeriod.userAttachments" />
    </template>

    <template v-if="auditPeriod.auditorAttachments && auditPeriod.auditorAttachments.length">
      <v-card-title>
        {{ $t("auditPeriodFiles.auditorFiles") }}

        <v-spacer></v-spacer>

        <v-dialog v-model="auditorAttachmentsDialog" persistent max-width="600">
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="secondary" icon>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline">
              {{ $t("auditor.download.confirmation.title") }}
            </v-card-title>

            <v-card-text>
              <Markdown :value="$t('auditor.download.confirmation.description')" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="warning" @click="auditorAttachmentsDialog = false">
                {{ $t("auditor.download.confirmation.cancel") }}
              </v-btn>

              <v-btn
                color="primary"
                @click="
                  download(auditPeriod.auditorAttachments);
                  auditorAttachmentsDialog = false;
                "
              >
                {{ $t("auditor.download.confirmation.accept") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>

      <AuditPeriodFilesTable :attachments="auditPeriod.auditorAttachments" />
    </template>
  </v-card>
</template>

<script>
import { saveAs } from "file-saver";
import AuditPeriodFilesTable from "./AuditPeriodFilesTable.vue";

export default {
  components: {
    AuditPeriodFilesTable,
  },

  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      userAttachmentsDialog: false,
      auditorAttachmentsDialog: false,
    };
  },

  methods: {
    download(attachments) {
      attachments.forEach((attachment, index) => {
        setTimeout(
          () =>
            fetch(attachment.file.url)
              .then((res) => res.blob())
              .then((blob) => {
                saveAs(blob, attachment.file.name);
              }),
          index * 500
        );
      });
    },
  },
};
</script>
